import {IntermediatePart} from "../../intermediatePart";
import {Shower} from "../../parts/shower";
// import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import {ShowerAccessories} from "../../parts/showerAccessories";
import {CORNER_SHELVES_POSITIONS} from "../../constants";

export default class WindowKits extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "window_kits";
    this.dbName = window.location.href.includes("quotekandb") ? "Window Kits" : "Window Kit";
    this.partName = "Window Kits";
    this.translateId = "visualizer.bathroom.window.kits";
    this.canBeDisabled = true;
  }

  // navigationSubItems(filters, searchText) {
  //   const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
  //   const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
  //   const windowParent = this.getParent();
  //   const accessoriesParent = windowParent.layout.parts[ShowerAccessories.id];
  //   featuresToDisplay.forEach(feature => {
  //     if (accessoriesParent && accessoriesParent.showerPod && !accessoriesParent.showerPod.disabled) {
  //       feature.matchesMetaFailed = "shower_pod";
  //     } else if (accessoriesParent.cornerShelf && !accessoriesParent.cornerShelf.disabled
  //       && CORNER_SHELVES_POSITIONS.some(pos => accessoriesParent.cornerShelf.layerPositions[pos] && !pos.includes("3"))) {
  //       feature.matchesMetaFailed = "corner_shelf";
  //     } else if (feature.matchesMetaFailed) {
  //       feature.matchesMetaFailed = false;
  //     }
  //   });
  //   return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  // }

  // handleChangeParent(nonCompatibleWith) {
  //   if (nonCompatibleWith === "Shower Pod") {
  //
  //   }
  // }
  handleChangeParent() {
    // this.removeInterferingParts();
    this.getParent().disabled = false;
    this.handleClick();
  }

  removeInterferingParts = () => {
    const kitsParent = this.getParent();
    const windowParent = kitsParent.getParent();
    const accessoriesParent = windowParent.layout.parts[ShowerAccessories.id];
    if (accessoriesParent) {
      // if (accessoriesParent.showerPod) {
      //   accessoriesParent.showerPod.disabled = true;
      // }
      if (accessoriesParent.cornerShelf) {
        CORNER_SHELVES_POSITIONS.forEach(pos => {
          if (accessoriesParent.cornerShelf.layerPositions[pos] && !pos.includes("3")) {
            accessoriesParent.cornerShelf.layerPositions[pos] = null;
          }
        })
      }
    }
  }

  // disabledClick() {
  //   if (!this.disabled) {
  //     this.removeInterferingParts();
  //   }
  // }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const windowParent = this.getParent();
    const layout = windowParent.layout;
    const showerParent = layout.parts[Shower.id];
    const showerSize = showerParent.showerSize();
    if (showerParent && showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      });
    }
    // if (windowBody && this.windowNeededLayouts.includes(layout.type)) {
    //   conditions.push({
    //     propName: "Window",
    //     propValue: (windowBody && windowBody.activeFeature && windowBody.disabled) ? "Off" : "On"
    //   })
    // }
    return conditions
  }
}
